import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-create-purchase-category',
  templateUrl: './create-purchase-category.component.html',
  styleUrls: ['./create-purchase-category.component.scss'],
})
export class CreatePurchaseCategoryComponent {
  code;
  name;
  description;
  loader: boolean = false;
  active: boolean = true;
  editBool:boolean=false;
  activeInd: boolean = true;
  item:any;
  fontStyle;
  id;
  pic;
  constructor(private service: ApiService,
    public handler: HandlerService,
    public router: Router,
    public translate: TranslateService,
    public auth: AuthService,  public location: LocationService, private bottomSheet: MatBottomSheet) { }

    ionViewWillEnter() {
      // this.fontStyle=localStorage.getItem('lang');
      let url=window.location.href    
      if(url.includes('edit-purchaseCategory')) {
        this.loader=true;
        this.editBool=true;
        this.id= window.location.href.split('/').pop();        
        this.service.getAllPurchaseCategoryById(this.id).subscribe((res:any)=>{
          this.item=res;
            this.code = res.code;
            this.name = res.name;
            this.pic = res.img;
            this.description= res.description;
            this.activeInd = res.activeInd;
            this.loader = false;
        })
        err=>{
          this.handler.err(err);
          this.loader=false;
        }
      }
      else{
        this.editBool = false;
      }
    }
    
      create() {
        if (this.code) {
          this.code = this.code.toUpperCase();
        }
        this.loader = true;
        var post={
          "code": this.code,
          "name": this.name,
          "description": this.description,
          "img": this.pic,
          activeInd: true
        }
        this.service.createPurchaseCategory(post).subscribe(res=>{
          this.handler.res("Category Created Successfully");
          this.loader = false;
          this.name=undefined;
          this.router.navigate(['/manage-items-Category'])
    
        },
        err=>{
          this.loader=false;
          this.handler.err(err);
        })
      }
      editService() {
        // if(this.auth.checkCapability('MNGITEMS')){
          this.loader = true;
        if (this.name) {
          this.name = this.name.toUpperCase();
        }
        this.loader = true;
        this.item.code=this.code;
        this.item.name=this.name;
        this.item.img=this.pic;
        this.item.description=this.description;
        this.item.activeInd = this.activeInd;
       this.service.updatePurchaseCategory(this.id,this.item).subscribe(res=>{
          this.handler.res("Category Updated Successfully");
          this.loader = false;
          this.router.navigate(['/manage-items-Category'])
    
        },
        err=>{
          this.loader=false;
          this.handler.err(err);
    
        })
    
        // }
        // else{
        //   this.handler.res("User Doesnot Have a Access")
        // }
      }
      cancel() {
        this.router.navigate(['/manage-items-Category']);
      }
      handleFile(files) {
        var img = new Image();
        img.src = URL.createObjectURL(files[0]);
        img.onload = (data) => {
          var canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          this.pic = canvas.toDataURL('image/jpeg', 0.07);
        }
    }
}

